export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/users/service-provider/:id/financials', 'admin.service-provider-user-financials')
    .when('/admin/users/service-provider/:id/info', 'admin.service-provider-user-info')
    .when('/admin/users/service-provider/:id/schedule', 'admin.service-provider-user-schedule')
    .when('/admin/users/service-provider/:id/service-bookings/:requestId/reporting', 'admin.service-provider-user-service-booking-reporting')
    .when('/admin/users/service-provider/:id/service-bookings/:requestId/reassign', 'admin.service-provider-user-service-booking-reassign')
    .when('/admin/users/service-provider/:id/service-bookings/:requestId', 'admin.service-provider-user-service-booking-info')
    .when('/admin/users/service-provider/:id/service-bookings', 'admin.service-provider-user-service-bookings')
    .when('/admin/users/service-provider/:id/services', 'admin.service-provider-user-services')
    .when('/admin/users/service-provider/:id/services/:type', 'admin.service-provider-user-service-bucket-info')
    .when('/admin/users/service-provider/:id/settings', 'admin.service-provider-user-settings')
    .when('/admin/users/service-provider/:id/work-areas', 'admin.service-provider-user-work-areas')
    .when('/admin/users/service-provider/:id/bicycle-shops', 'admin.service-provider-user-bicycle-shops')
    .when('/admin/users/service-provider/:id/pick-up-and-drop-off', 'admin.service-provider-user-pick-up-and-drop-off')

    .within('admin')

    .segment('service-provider-user-financials', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-financials-page></admin-service-provider-financials-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-financials.module" */ "./service-provider-financials/admin-service-provider-financials.module");
      }
    })

    .segment('service-provider-user-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-personal-info-page></admin-service-provider-personal-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-personal-info.module" */ "./service-provider-personal-info/admin-service-provider-personal-info.module");
      }
    })

    .segment('service-provider-user-schedule', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-schedule-page></admin-service-provider-schedule-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-schedule.module" */ "./service-provider-schedule/admin-service-provider-schedule.module");
      }
    })

    .segment('service-provider-user-service-bookings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-service-bookings-page></admin-service-provider-service-bookings-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-service-bookings.module" */ "./service-provider-service-bookings/admin-service-provider-service-bookings.module");
      }
    })

    .segment('service-provider-user-service-booking-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN', isRequest: true},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
          url: '/admin/users/service-provider/:id/service-bookings',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
        }
      ],
      template: '<admin-service-provider-service-booking-info-page></admin-service-provider-service-booking-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-service-booking-info.module" */ "./service-provider-service-booking-info/admin-service-provider-service-booking-info.module");
      }
    })

    .segment('service-provider-user-service-booking-reporting', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
          url: '/admin/users/service-provider/:id/service-bookings',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/users/service-provider/:id/service-bookings/:requestId',
          params: {
            requestId: ':requestId',
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
        }
      ],
      template: '<admin-service-provider-service-booking-reporting-page></admin-service-provider-service-booking-reporting-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-service-booking-reporting.module" */ "./service-provider-service-booking-reporting/admin-service-provider-service-booking-reporting.module");
      }
    })

    .segment('service-provider-user-service-booking-reassign', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
          url: '/admin/users/service-provider/:id/service-bookings',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/users/service-provider/:id/service-bookings/:requestId',
          params: {
            requestId: ':requestId',
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.booking_reassign',
        }
      ],
      template: '<admin-service-provider-service-booking-reassign-page></admin-service-provider-service-booking-reassign-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-service-booking-reassign.module" */ "./service-provider-service-booking-reassign/admin-service-provider-service-booking-reassign.module");
      }
    })

    .segment('service-provider-user-services', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-services-page></admin-service-provider-services-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-services.module" */ "./service-provider-services/admin-service-provider-services.module");
      }
    })

    .segment('service-provider-user-service-bucket-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
          url: '/admin/users/service-provider/:id/services',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_bucket_info',
        }
      ],
      template: '<admin-service-provider-service-bucket-info-page></adminServiceProviderServiceBucketInfoPage>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-service-bucket-info.module" */ "./service-provider-service-bucket-info/admin-service-provider-service-bucket-info.module");
      }
    })

    .segment('service-provider-user-settings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-settings-page></admin-service-provider-settings-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-settings.module" */ "./service-provider-settings/admin-service-provider-settings.module");
      }
    })

    .segment('service-provider-user-work-areas', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-work-areas-page></admin-service-provider-work-areas-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-work-areas.module" */ "./service-provider-work-areas/admin-service-provider-work-areas.module");
      }
    })

    .segment('service-provider-user-bicycle-shops', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-bicycle-shops-page></admin-service-provider-bicycle-shops-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-bicycle-shops.module" */ "./service-provider-bicycle-shops/admin-service-provider-bicycle-shops.module");
      }
    })

    .segment('service-provider-user-pick-up-and-drop-off', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.service_provider_info',
        }
      ],
      template: '<admin-service-provider-pick-up-and-drop-off-page></admin-service-provider-pick-up-and-drop-off-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-pick-up-and-drop-off.module" */ "./service-provider-pick-up-and-drop-off/admin-service-provider-pick-up-and-drop-off.module");
      }
    })
}
